import store, { StoreAPI } from 'store2'

export class Storage {
  private readonly ns: StoreAPI
  private readonly uuid: string

  constructor(namespace: string, uuid: string) {
    this.ns = store.namespace(namespace)
    this.uuid = uuid
  }

  public get(key: string, shared = false): any {
    const now = new Date()
    const storeKey = shared ? key : `${this.uuid}.${key}`
    const item = this.ns.get(storeKey)

    if (!item) {
      return null
    }

    // compare the expiry time of the item with the current time
    if (now.getTime() > item.expiry) {
      this.unset(key, shared)
      return null
    }

    return item.value
  }

  public set(key: string, value: any, shared = false, ttlInMinutes = 60): void {
    const now = new Date()
    const storeKey = shared ? key : `${this.uuid}.${key}`
    const expiry = ttlInMinutes * 1000 * 60

    // `item` is an object which contains the original value
    // as well as the time when it's supposed to expire
    const item = {
      value: value,
      expiry: now.getTime() + expiry
    }

    this.ns.set(storeKey, item)
  }

  public unset(key: string, shared = false): void {
    const storeKey = shared ? key : `${this.uuid}.${key}`
    this.ns.remove(storeKey)
  }
}
